<template>
  <div>
    <pt-form-item label="是否完成：" labelWidth="100px" :required="true">
      <el-radio-group v-model="form.result" name="result" v-validate="'required'" data-vv-as="是否合格">
        <el-radio label="SAMPLE_QUALIFIED">完成</el-radio>
        <el-radio label="HAS_ERROR_WAIT_FUTURE_ACTION">异常</el-radio>
        <!-- <el-radio label="RELEASE_CHIP_SLOT">释放排版</el-radio> -->
      </el-radio-group>
    </pt-form-item>
    <template v-if="form.result == 'HAS_ERROR_WAIT_FUTURE_ACTION'">
      <pt-form-item label="原因：" labelWidth="100px" :required="true">
        <wt-selector :options="options" name="reason" data-vv-as="原因" v-validate="'required'" v-model="form.reason" :clearable="true" :allow-create="true" :filterable="true" @mousedown.stop.native @click.stop.native :props="reasonProps" :noDataText="'暂无选项，请您直接录入内容'"></wt-selector>
      </pt-form-item>
    </template>
    <pt-form-item label="备注：" labelWidth="100px">
      <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 6 }" v-model="form.comment" class="texta" placeholder="请填写备注" @mousedown.stop.native @click.stop.native></el-input>
    </pt-form-item>

  </div>
</template>

<script>
import { validate } from 'utils/validate'
import { next } from '../status.js'
const AbnormalReasonType = 'DATA_RETURN_UNQUALIFIED_REASON'
export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    detailIn: {
      type: Boolean,
      default: false
    },
    orderStatus: [Array]
  },
  data () {
    return {
      title: '数据回传',
      form: {
        result: 'SAMPLE_QUALIFIED'
      },
      pass: false,
      reasonObj: {
        have: false,
        reasons: []
      },
      options: [],
      reasonProps: {
        label: 'name',
        value: 'value'
      }
    }
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    },
    getReason (val) {
      for (var i in this.options) {
        if (this.options[i].id === val) {
          return this.options[i].name
        }
      }
    },
    next () {
      let data = {
        orderIds: [this.order.id],
        action: this.status
      }
      if (this.form.result === 'HAS_ERROR_WAIT_FUTURE_ACTION') {
        data.orderStatusDetail = {
          orderStatusResult: this.form.result,
          reason: this.getReason(this.form.reason) ? this.getReason(this.form.reason) : this.form.reason,
          comment: this.form.comment
        }
        let params = {
          type: AbnormalReasonType,
          value: this.getReason(this.form.reason) ? this.getReason(this.form.reason) : this.form.reason,
          options: this.options
        }
        this.$emit('add-abnormalReason', params)
      } else {
        data.orderStatusDetail = {
          orderStatusResult: this.form.result,
          comment: this.form.comment
        }
      }
      return next.call(this, data)
    },
    getAbnormalReason () {
      this.$store.dispatch('getAbnormalReason', AbnormalReasonType).then(res => {
        this.options = res
      })
    }
  },
  created () {
    this.getAbnormalReason()
  }

}
</script>

<style lang="less">
</style>
